'use client';

import { OngoingSeasonPage } from 'app/(mainNavigation)/quest/ongoing-season/my/OngoingSeasonPage';

export default function Page() {
  return (
    <>
      <title>진행 중인 시즌 | 디리토</title>
      <OngoingSeasonPage />
    </>
  );
}
